import { render, staticRenderFns } from "./eventWorkloadEstimateDetail.vue?vue&type=template&id=588f4ba4&scoped=true&"
import script from "./eventWorkloadEstimateDetail.vue?vue&type=script&lang=js&"
export * from "./eventWorkloadEstimateDetail.vue?vue&type=script&lang=js&"
import style0 from "./eventWorkloadEstimateDetail.vue?vue&type=style&index=0&id=588f4ba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588f4ba4",
  null
  
)

export default component.exports